import { render, staticRenderFns } from "./AppScreenshotsScreenshot.vue?vue&type=template&id=722a27db"
import script from "./AppScreenshotsScreenshot.vue?vue&type=script&lang=js"
export * from "./AppScreenshotsScreenshot.vue?vue&type=script&lang=js"
import style0 from "./AppScreenshotsScreenshot.vue?vue&type=style&index=0&id=722a27db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports